const SET_PROJECTESTIMATE_LIST_DATA = "SET_PROJECTESTIMATE_LIST_DATA";
const RESET_PROJECTESTIMATE_LIST_DATA = "RESET_PROJECTESTIMATE_LIST_DATA";
const REFRESH_COST_ESTIMATION = "REFRESH_COST_ESTIMATION";
const REFRESH_KICK_OFF = "REFRESH_KICK_OFF";
const REFRESH_TOTALS = "REFRESH_TOTALS";
const RESET_STATE = "RESET_STATE";

export function setProjectEstimateListData(payload) {
  return {
    type: SET_PROJECTESTIMATE_LIST_DATA,
    payload,
  };
}

export function resetProjectEstimateListData(key = "") {
  return {
    type: RESET_PROJECTESTIMATE_LIST_DATA,
    payload: {
      key,
    },
  };
}

export function setRefreshCostEstimation(flag) {
  return {
    type: REFRESH_COST_ESTIMATION,
    flag,
  };
}

export function setRefreshKickOff(flag) {
  return {
    type: REFRESH_KICK_OFF,
    flag,
  };
}

export function setRefreshTotals(flag) {
  return {
    type: REFRESH_TOTALS,
    flag,
  };
}

export function resetState() {
  return {
    type: RESET_STATE,
  };
}

const INIT_STATE = {
  listProjectsEstimate: {
    expandedTableContent: [],
    expandedRowKeys: [],
  },
  refreshCostEstimation: null,
  refreshKickOff: null,
  refreshTotals: null,
};

export default function ProjectEstimateDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case SET_PROJECTESTIMATE_LIST_DATA:
      newState.listProjectsEstimate = action.payload;
      break;
    case RESET_PROJECTESTIMATE_LIST_DATA:
      if (action.payload.key === "") {
        newState.listProjectsEstimate = {
          expandedTableContent: [],
          expandedRowKeys: [],
        };
      } else {
        newState.listProjectsEstimate[action.payload.key] = [];
      }
      break;
    case REFRESH_COST_ESTIMATION:
      newState.refreshCostEstimation = action.flag;
      break;
    case REFRESH_KICK_OFF:
      newState.refreshKickOff = action.flag;
      break;
    case REFRESH_TOTALS:
      newState.refreshTotals = action.flag;
      break;
    case RESET_STATE:
      newState = INIT_STATE;
      break;
    default:
      break;
  }
  return newState;
}
